<template>
  <div>
    <v-row dense>
      <v-col cols="auto">
        <v-text-field v-model="folio" :label="itemAction.name" outlined dense />
      </v-col>
      <v-col cols="auto">
        <v-btn color="success darken-1" depressed @click="ValidateFolio"> Validar </v-btn>
      </v-col>
    </v-row>
    <v-alert v-if="showAlert" type="error" outlined dense>Campo {{ itemAction.name }} no debe ser vacio</v-alert>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'SearchDinamicField',
  props: ['itemAction', 'onSuccess', 'setterModel'],
  data: () => ({
    folio: '',
    showAlert: false,
    object: null,
    objects: [],
    findObject: null
  }),
  mounted () {
    this.setModel(this.setterModel)
  },
  methods: {
    ValidateFolio () {
      if (this.folio === '') {
        this.showAlert = true
        setTimeout(() => {
          this.showAlert = false
        }, 1500)
        return
      }
      this.getDinamicData(this.folio)
    },
    itemText (item) {
      if (item && (this.itemAction.nameid === 'cve_empleado' || this.itemAction.nameid === 'empleado_id')) {
        return `${item.NombreCompleto}`
      } else if (item && this.itemAction.nameid === 'adscripcion_id') {
        return `${item.NombreCompleto} - ${item.departamento} - ${item.categoria}`
      } else if (item && (this.itemAction.nameid === 'departamento_id' || this.itemAction.nameid === 'lugar_nacimiento_id' || this.itemAction.nameid === 'localidad_id')) {
        return `${item.nombre}`
      } else if (item && this.itemAction.nameid === 'ejercicio_id') {
        return `${item.descripcion}`
      }
      return 'No Title'
    },
    getDinamicData (name) {
      const token = this.$cookies.get('token_sirh')
      axios.get(`${this.itemAction.url}/${name}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        this.onSuccess({ id: this.itemAction.nameid, data: response.data, field: this.itemAction })
      }).catch(error => {
        if (error == null) {}
      })
    },
    postDinamicData (name) {
      const token = this.$cookies.get('token_sirh')
      axios.post(`${this.itemAction.url}`, { name }, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        this.objects = []
        this.objects.push(...response.data)
      }).catch(error => {
        if (error == null) {}
      })
    },
    clearData (e) {
      this.onSuccess({ id: this.itemAction.nameid, data: null })
    },
    setModel (val) {}
  },
  watch: {
    findObject (val) {
      if (val === null || val === '') return

      if (this.itemAction.method) {
        this.postDinamicData(val.replace(' ', '_'))
      } else {
        this.getDinamicData(val.replace(' ', '_'))
      }
    }
  }
}
</script>
  <style>
  </style>
